import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import BaseCommand from './BaseCommand';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { saveReviewData } from '../../redux/review/review.slice';
import { PaymentMethodsCommandNames } from '@chegg/commerce-utils';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
export var ReviewViewCommand = /*#__PURE__*/function (_BaseCommand) {
  function ReviewViewCommand() {
    _classCallCheck(this, ReviewViewCommand);
    return _callSuper(this, ReviewViewCommand, arguments);
  }
  _inherits(ReviewViewCommand, _BaseCommand);
  return _createClass(ReviewViewCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var updateResponse, taxWithCurrencyFormat, totalWithCurrencyFormat, renewalPriceWithCurrencyFormat, totalWithoutCurrencyFormat, itemHasFreeTrial, subtotalWithCurrencyFormat, errors, data, success, _data$orderSummary$ta, _data$orderSummary$to, _items$0$billingDetai, _items$, _items$0$billingDetai2, _items$2, _data$orderSummary$to2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.state.review.selectedMop && Object.keys(this.state.review.selectedMop).length > 0)) {
                _context.next = 16;
                break;
              }
              this.dispatch(savePaymentMethodsCommands([{
                commandName: PaymentMethodsCommandNames.SELECTED_MOP_VIEW
              }]));
              _context.next = 4;
              return this.client.cartAPI.updateCart(this.state.cart.cartId, this.state.cart.items,
              //@ts-ignore
              this.state.review.selectedMop);
            case 4:
              updateResponse = _context.sent;
              taxWithCurrencyFormat = '';
              totalWithCurrencyFormat = '';
              renewalPriceWithCurrencyFormat = '';
              totalWithoutCurrencyFormat = 0;
              itemHasFreeTrial = false; // setting this from cart just incase update cart api fails
              subtotalWithCurrencyFormat = this.state.cart.subtotalWithCurrencyFormat;
              errors = updateResponse.errors, data = updateResponse.data, success = updateResponse.success;
              if (!success && errors) {
                sendNewRelicMessage('Error fetching response from updateCart', {
                  errors: JSON.stringify(errors)
                });
              } else {
                taxWithCurrencyFormat = (_data$orderSummary$ta = data === null || data === void 0 ? void 0 : data.orderSummary.taxWithCurrencyFormat) !== null && _data$orderSummary$ta !== void 0 ? _data$orderSummary$ta : '';
                totalWithCurrencyFormat = (_data$orderSummary$to = data === null || data === void 0 ? void 0 : data.orderSummary.totalWithCurrencyFormat) !== null && _data$orderSummary$to !== void 0 ? _data$orderSummary$to : '';
                subtotalWithCurrencyFormat = data !== null && data !== void 0 && data.orderSummary.subtotalWithCurrencyFormat && data.orderSummary.subtotalWithCurrencyFormat !== '' ? data.orderSummary.subtotalWithCurrencyFormat : subtotalWithCurrencyFormat;
                itemHasFreeTrial = (_items$0$billingDetai = data === null || data === void 0 || (_items$ = data.items[0]) === null || _items$ === void 0 || (_items$ = _items$.billingDetails) === null || _items$ === void 0 ? void 0 : _items$.hasTrial) !== null && _items$0$billingDetai !== void 0 ? _items$0$billingDetai : false;
                renewalPriceWithCurrencyFormat = (_items$0$billingDetai2 = data === null || data === void 0 || (_items$2 = data.items[0]) === null || _items$2 === void 0 || (_items$2 = _items$2.billingDetails) === null || _items$2 === void 0 ? void 0 : _items$2.renewalPriceWithCurrencyFormat) !== null && _items$0$billingDetai2 !== void 0 ? _items$0$billingDetai2 : '';
                totalWithoutCurrencyFormat = (_data$orderSummary$to2 = data === null || data === void 0 ? void 0 : data.orderSummary.total) !== null && _data$orderSummary$to2 !== void 0 ? _data$orderSummary$to2 : 0;
              }
              this.dispatch(saveReviewData({
                currentStep: 2,
                taxWithCurrencyFormat: taxWithCurrencyFormat,
                totalWithCurrencyFormat: totalWithCurrencyFormat,
                subtotalWithCurrencyFormat: subtotalWithCurrencyFormat,
                renewalPriceWithCurrencyFormat: renewalPriceWithCurrencyFormat,
                totalWithoutCurrencyFormat: totalWithoutCurrencyFormat,
                itemHasFreeTrial: itemHasFreeTrial
              }));
              _context.next = 17;
              break;
            case 16:
              this.dispatch(savePaymentMethodsCommands([{
                commandName: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD
              }]));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/ReviewViewCommand.js
// module id = 4693
// module chunks = 11